<template>
    <div v-if="audioSources.length" v-tooltip="{ content: 'Play/Pause: P</br>Rewind: R</br>Forward: F', trigger: 'hover'}" class="reader-player">
        <div class="player-progress-container">
            <div class="player-progress" :style="{ width: selectedThemeProgress +'%' }" />
        </div>
        <div class="row no-gutters align-items-center">
            <player-menu :is-main-player="isMainPlayer" />
            <div class="col theme-name d-flex flex-column text-truncate">
                <h5 v-if="showTitle" class="d-none d-md-block player-title text-truncate">
                    Listen to {{ selectedBookInsightTitle }}
                </h5>
                <h5 v-if="showTitle" class="d-block d-md-none player-title text-truncate">
                    Listen Now
                </h5>
                <small class="text-truncate">{{ selectedThemeTitle }}</small>
            </div>
            <div
                class="ml-auto col-auto mr-auto"
            >
                <div class="row no-gutters align-items-center player-controls">
                    <div
                        class="col rewind"
                        :class="{ 'rewind-running' : isRewinding }"
                        @click="rewind"
                    >
                        <svg
                            width="37"
                            height="38"
                            viewBox="0 0 37 38"
                        >
                            <path
                                fill="#FFFFFF"
                                fill-rule="nonzero"
                                d="M17.936.396c10.195 0 18.46 8.264 18.46 18.46 0 10.194-8.265 18.458-18.46 18.458-2.035 0-4.037-.33-5.945-.978a1.188 1.188 0 0 1 .765-2.249c1.661.565 3.405.852 5.18.852 8.884 0 16.085-7.2 16.085-16.084 0-8.883-7.201-16.084-16.085-16.084A16.074 16.074 0 0 0 4.644 9.794l5.683-.886a1.03 1.03 0 1 1 .317 2.034L2.52 12.208a1.03 1.03 0 0 1-1.175-.852L.032 3.238a1.03 1.03 0 1 1 2.032-.329l.844 5.223A18.447 18.447 0 0 1 17.936.396zM9.692 23.235c.584.58.875 1.351.875 2.297 0 1.36-.487 2.423-1.457 3.169-.955.734-2.3 1.097-4.027 1.097-1.517 0-2.802-.248-3.856-.746l-.136-.215v-1.914c0-.176.185-.29.343-.213a8.324 8.324 0 0 0 1.754.633c.618.148 1.21.222 1.776.222.991 0 1.718-.18 2.184-.53.448-.336.674-.86.674-1.595 0-.632-.242-1.078-.735-1.37-.524-.31-1.377-.47-2.553-.47H3.37l-.237-.238v-1.75l.237-.237h1.181c2.02 0 2.967-.654 2.967-1.978 0-.506-.157-.881-.473-1.145-.324-.272-.82-.412-1.496-.412a4.75 4.75 0 0 0-1.395.205c-.446.136-.983.405-1.607.81l-.324-.063-1.053-1.502.054-.327c1.269-.934 2.744-1.402 4.417-1.402 1.397 0 2.5.304 3.303.919.817.626 1.229 1.496 1.229 2.587 0 .904-.267 1.667-.8 2.277-.37.422-.843.746-1.415.974.726.186 1.305.491 1.733.917zm11.689-.55c0 2.367-.383 4.138-1.161 5.313-.794 1.198-2.012 1.8-3.627 1.8-1.568 0-2.772-.622-3.586-1.855-.799-1.21-1.193-2.964-1.193-5.259 0-2.405.383-4.19 1.162-5.355.793-1.19 2.008-1.786 3.617-1.786 1.574 0 2.781.625 3.595 1.865.799 1.216 1.193 2.975 1.193 5.276zm-6.913 0c0 1.792.183 3.064.54 3.806.336.7.853 1.037 1.585 1.037.73 0 1.251-.342 1.594-1.055.363-.755.55-2.021.55-3.789 0-1.762-.187-3.03-.55-3.794-.344-.722-.864-1.069-1.594-1.069-.73 0-1.249.34-1.585 1.046-.357.749-.54 2.025-.54 3.817z"
                            />
                        </svg>
                    </div>
                    <a
                        href="#"
                        class="col play-button"
                        :class="{ 'play-running' : isPlay }"
                        @click.prevent="togglePlay"
                    >
                        <div class="play-button-bg">
                            <svg
                                v-if="isPlaying"
                                width="36"
                                height="36"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="#FFFFFF"
                                    fill-rule="nonzero"
                                    d="M17.137 18.342V5.658A.671.671 0 0 0 16.453 5h-2.267a.671.671 0 0 0-.683.658v12.684c0 .363.306.658.683.658h2.267a.671.671 0 0 0 .684-.658M9.95 19H7.683A.67.67 0 0 1 7 18.342V5.658A.67.67 0 0 1 7.683 5h2.268c.377 0 .683.294.683.658v12.684a.671.671 0 0 1-.683.658"
                                />
                            </svg>
                            <svg
                                v-else
                                width="36"
                                height="36"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="#FFFFFF"
                                    fill-rule="nonzero"
                                    d="M17.828 11.185l-7.507-5.938c-.344-.258-.787-.329-1.181-.14-.394.163-.64.539-.64.961v11.876c0 .422.246.798.64.962.148.07.32.094.468.094.246 0 .516-.094.713-.235l7.507-5.937c.247-.212.394-.493.394-.822 0-.305-.147-.61-.394-.821z"
                                />
                            </svg>
                        </div>
                    </a>
                    <div
                        class="col forward"
                        :class="{ 'forward-running' : isForwarding }"
                        @click="forward"
                    >
                        <svg
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                        >
                            <path
                                fill="#FFFFFF"
                                fill-rule="nonzero"
                                d="M19.221 2.77c-8.883 0-16.084 7.202-16.084 16.085 0 8.883 7.2 16.084 16.084 16.084 1.776 0 3.52-.287 5.18-.852a1.187 1.187 0 1 1 .765 2.249c-1.907.649-3.91.978-5.945.978-10.195 0-18.46-8.264-18.46-18.459S9.027.395 19.222.395A18.447 18.447 0 0 1 34.25 8.133l.845-5.223a1.03 1.03 0 1 1 2.032.329l-1.313 8.118a1.03 1.03 0 0 1-1.174.852l-8.126-1.266a1.03 1.03 0 1 1 .317-2.034l5.683.886a16.074 16.074 0 0 0-13.292-7.023zm5.008 20.465c.584.58.876 1.351.876 2.297 0 1.36-.487 2.423-1.458 3.169-.955.734-2.3 1.097-4.027 1.097-1.516 0-2.802-.248-3.855-.746l-.136-.215v-1.914c0-.176.185-.29.342-.213a8.324 8.324 0 0 0 1.755.633c.617.148 1.209.222 1.776.222.99 0 1.717-.18 2.183-.53.448-.336.674-.86.674-1.595 0-.632-.241-1.078-.735-1.37-.524-.31-1.377-.47-2.553-.47h-1.162l-.238-.238v-1.75l.238-.237h1.18c2.02 0 2.968-.654 2.968-1.978 0-.506-.158-.881-.474-1.145-.324-.272-.82-.412-1.496-.412a4.75 4.75 0 0 0-1.395.205c-.446.136-.983.405-1.607.81l-.323-.063-1.053-1.502.053-.327c1.269-.934 2.744-1.402 4.417-1.402 1.397 0 2.5.304 3.304.919.816.626 1.228 1.496 1.228 2.587 0 .904-.267 1.667-.8 2.277-.37.422-.843.746-1.415.974.726.186 1.305.491 1.733.917zm11.689-.55c0 2.367-.383 4.138-1.161 5.313-.793 1.198-2.012 1.8-3.627 1.8-1.568 0-2.772-.622-3.586-1.855-.799-1.21-1.193-2.964-1.193-5.259 0-2.405.383-4.19 1.162-5.355.793-1.19 2.008-1.786 3.617-1.786 1.574 0 2.782.625 3.596 1.865.798 1.216 1.192 2.975 1.192 5.276zm-6.913 0c0 1.792.184 3.064.54 3.806.336.7.854 1.037 1.585 1.037.73 0 1.251-.342 1.594-1.055.363-.755.55-2.021.55-3.789 0-1.762-.187-3.03-.55-3.794-.343-.722-.864-1.069-1.594-1.069-.73 0-1.248.34-1.585 1.046-.356.749-.54 2.025-.54 3.817z"
                            />
                        </svg>
                    </div>
                    <div
                        v-tooltip="{ content: `${rates.join(', ')}`, trigger: 'hover'}"
                        class="col-auto speed"
                        @click="changeRate"
                    >
                        {{ rate }}x
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import playerEventsMixins from "./playerEventsMixins";

export default {
    name: "PlayerInterface",
    components: {
        playerMenu: () => import(/* webpackChunkName: "audio-player-menu"*/"@c/audio-player/menu")
    },
    mixins: [playerEventsMixins],
    props: {
        showTitle: {
            type: Boolean,
            default: true
        },
        isMainPlayer: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isRewinding: false,
            isPlay: false,
            isForwarding: false
        };
    },
    computed: {
        ...mapState({
            selectedAudioSource: state => state.NonfictionPlayer.selectedAudioSource,
            bookInsight: state => state.NonfictionPlayer.bookInsight,
            audioSources: state => state.NonfictionPlayer.audioSources,
            isPlaying: state => state.NonfictionPlayer.isPlaying,
            rate: state => state.NonfictionPlayer.rate,
            rates: state => state.NonfictionPlayer.rates
        }),
        ...mapGetters({
            currentAudioSource: "NonfictionPlayer/currentAudioSource"
        }),
        selectedThemeProgress() {
            if (this.audioSources.length) {
                return this.audioSources[this.selectedAudioSource].progress;
            }
            return 0;
        },
        selectedThemeTitle() {
            if (this.audioSources.length) {
                return this.audioSources[this.selectedAudioSource].title;
            }
            return "";
        },
        selectedBookInsightTitle() {
            if (Object.keys(this.bookInsight).length) {
                return this.bookInsight.title
            }
            return "";
        }
    },
    methods: {
        togglePlay() {
            // The following block of code is intended for the forward animation
            this.isPlay = true;

            setTimeout(() => {
                this.isPlay = false;
            }, 100);

            this.$store.dispatch("NonfictionPlayer/toggle");
        },
        changeRate() {
            const currentRateIndex = this.rates.findIndex(rate => rate == this.rate);

            let rate = "1.0";
            if (this.rates.length > (currentRateIndex + 1)) {
                rate = this.rates[currentRateIndex + 1];
            }

            this.$store.dispatch("NonfictionPlayer/setRate", rate);
        },
        forward() {
            // The following block of code is intended for the forward animation
            this.isForwarding = true;

            setTimeout(() => {
                this.isForwarding = false;
            }, 100);

            this.$store.dispatch("NonfictionPlayer/setForward");
        },
        rewind() {
            // The following block of code is intended for the rewind animation
            this.isRewinding = true;

            setTimeout(() => {
                this.isRewinding = false;
            }, 100);

            this.$store.dispatch("NonfictionPlayer/setRewind");
        }
    }
}
</script>

<style lang="scss">
    .reader-player {
        background-color: $medium-gray;
        border: 1px solid rgba(151, 151, 151, 0.1);
        border-radius: 10px;
        box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.2);
        padding: 15px 0;
        position: relative;

        .player-progress-container {
            position: absolute;
            width: 100%;
            top: 0;
            overflow: hidden;
            height: 100%;
            border-radius: inherit;

            .player-progress {
                height: 2px;
                background-color: $primary-color;
            }
        }


        .burger-menu {
            padding-left: 35px;
            padding-right: 35px;
            position: unset;

            .themes-player-dropdown {
                display: flex;
                position: unset;

                .bp-dropdown__btn {
                    position: relative;
                    width: 25px;
                    height: 20px;

                    .themes-close {
                        display: none;
                    }
                }

                .bp-dropdown__btn--active {
                    background-color: transparent;

                    .themes-menu {
                        display: none;
                    }

                    .themes-close {
                        display: block;
                        margin: 0 auto;
                    }
                }

                .bp-dropdown__body {
                    left: 0 !important;
                    top: 80px !important;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.09);

                    @media (max-width: $md) {
                        top: 60px !important;
                    }

                    ul {
                        padding-left: 15px;
                        padding-right: 15px;

                        .col-12 {
                            padding-left: 0;
                            padding-right: 0;
                        }
                    }
                }
            }
        }

        .player-title {
            margin-bottom: 0;
            color: white;
            font-size: 23px;
            line-height: 32px;

            @media (max-width: $md) {
                font-size: 15px;
                line-height: 1.53;
            }
        }

        .theme-name {
            small {
                margin-bottom: 0;
                color: white;
                font-size: 13px;
                font-weight: 600;
                line-height: 18px;
                margin-right: 10px;
            }
        }

        .player-controls {
            div[class^='col'] {
                cursor: pointer;
            }

            .rewind, .forward, .play-button {
                transform: rotate(0deg) scale(1);
                transition: transform .1s ease-in;
            }

            .rewind {
                &.rewind-running {
                    transform: rotate(-15deg) scale(1.2);
                }
            }

            .play-button {
                padding-left: 20px;
                padding-right: 20px;

                .play-button-bg {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 60px;
                    height: 60px;
                    background-color: $dark-gray;
                    border-radius: 100%;
                }

                &.play-running {
                    transform: rotate(0deg) scale(1.3);
                }
            }

            .forward {
                &.forward-running {
                    transform: rotate(15deg) scale(1.2);
                }
            }

            .speed {
                color: white;
                font-size: 15px;
                font-weight: 600;
                line-height: 16px;
                padding-left: 20px;
                padding-right: 35px;
                -moz-user-select: none;
                -ms-user-select: none;
                -khtml-user-select: none;
                -webkit-user-select: none;
                -webkit-touch-callout: none;
            }
        }
    }
</style>
